import ErrorAlerting from "./ErrorAlerting";

export default ErrorAlerting;
